import { useContext } from "react";
import { FormContext } from "@/context";
import type { FormContextValue } from "@/context";

export const useFormContext = (): FormContextValue | null => useContext(FormContext);
